import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z","key":"svg-0"}]]

const IconCrown = createReactComponent('outline', 'crown', 'Crown', __iconNode);

export default IconCrown;